var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function BackToTop(el) {
  this.$el = $(el);

  $(window).one('vsc-page-ready', function() {
    var $scroll = $('html').hasClass('css-parallax') ? $('main') : $('html, body');

    this.$el.on('click', function(event) {
      event.preventDefault();

      console.log($scroll);

      $scroll.animate({
        scrollTop: 0
      }, 450);
    });
  }.bind(this));
}

module.exports = BackToTop;